import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as Paper from "../../layout/PaperFunctions";

import { Palette } from "../../../AppConfig";
import * as BSL_Common from "../../../components/BSL_CommonControls";
import BSL_Select from "../../../components/BSL_Select";
import BSL_ColourSelector from "../../../components/BSL_ColourSelector";
import BSL_TextInput from "../../../components/BSL_TextInput";
import * as APP from "../../../redux_store/appState";
import { MaxDeckBearerSpans, MaxDeckJoistSpans } from "../../../redux_store/jobState_Validation";

import { updateAreaSpecification, updateAreaSpecificationBeamPost } from "../../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../../redux_store/jobState_Schemas";

import SegmentedButtonGroup from "../../../components/SegmentedButtonGroup";
import { ListSubheader } from "@material-ui/core";
import BSL_CheckBox from "../../../components/BSL_CheckBox";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CrossCircleIcon from "@material-ui/icons/Cancel";
import CachedIcon from "@material-ui/icons/Cached";
import BSL_Dialog from "../../../components/BSL_Dialog";
import BSL_ControlContainer from "../../../components/BSL_ControlContainer";
import BSL_Button from "../../../components/BSL_Button";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import { toNumber } from "../../../components/Common";

const useStyles = makeStyles({
    root: {
        // background: "#D9E1E5",
        // maxWidth: '400px',
        // minWidth: '30px',
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "white",
        fontSize: "70%",
    },
    paper_root: {
        background: "#090909ad",
    },
    header_fail: {
        alignSelf: "flex-start",
        color: "#bd1414",
    },
    header_pass: {
        alignSelf: "flex-start",
        color: "#008200",
    },
    header_warning: {
        alignSelf: "flex-start",
        color: "#a66b00",
    },
    header_unknown: {
        alignSelf: "flex-start",
        color: "#b37f0b",
    },
    label: {
        flex: "1",
        font: "16px 'Univers45', sans-serif",
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        textAlign: "start",
    },
    bracing: {
        font: "13px 'Univers45', sans-serif",
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        textAlign: "start",
        textWrap: "wrap",
        padding: "0px 5px 10px 5px",
    },
});

export default function SpecDeckBeamPostTool(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const { areaIndex, currentHashCode } = props;
    const user = useSelector((state) => state.app?.user);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];

    const [newBearerLocation, setNewBearerLocation] = React.useState("");
    const [bearerLocationDialogValue, setBearerLocationDialogValue] = React.useState("");
    const [updateBearerLocation, setUpdateBearerLocation] = React.useState(0);

    const BeamPostParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];

    const designType = area_design_specs.SHAPE.DesignType;
    const area_config = config?.design_options?.[designType];
    const app = useSelector((state) => state.app);

    const beam_types = config.beam_types;
    const post_types = config.post_types;

    let colourMatch = {
        "Match Post": BeamPostParameters.PostCol,
        "Match Area 1 Post": job?.AreaSpecifications?.[0]?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PostCol,
    };

    const post = area_config?.post;
    let post_menu_items = [];
    if (post && post?.options) {
        for (let key in post.options) {
            post_menu_items.push(<ListSubheader key={key}>{key.replace("Beam", "Post")}</ListSubheader>);
            for (let key2 of post.options[key]) {
                const post = post_types?.[key2];
                if (post)
                    post_menu_items.push({
                        Key: post.id ? post.id : key2,
                        Display: post.name ? post.name.replace("Beam", "Post") : key2,
                        Thumbnail: post.thumbnail,
                    });
            }
        }
    }

    const beam1 = area_config.beam_1;
    let beam1_menu_items = [];

    if (beam1) {
        for (let key in beam1.options) {
            beam1_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
            for (let key2 of beam1.options[key]) {
                const beam = beam_types?.[key2];
                if (beam)
                    beam1_menu_items.push({
                        Key: beam.id ? beam.id : key2,
                        Display: beam.name ? beam.name : key2,
                        Thumbnail: beam.thumbnail,
                    });
            }
        }
    }

    let beam2 = area_config.beam_2;

    let beam2_menu_items = [];

    if (beam2) {
        for (let key in beam2.options) {
            beam2_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
            for (let key2 of beam2.options[key]) {
                const beam = beam_types?.[key2];
                if (beam)
                    beam2_menu_items.push({
                        Key: beam.id ? beam.id : key2,
                        Display: beam.name ? beam.name : key2,
                        Thumbnail: beam.thumbnail,
                    });
            }
        }
    }

    const updateBeamPostData =
        (dataField, in_value = null) =>
        (event, value = null) => {
            if (in_value !== null) value = in_value;
            else if (value === null) value = event?.target?.value ? event?.target?.value : event;
            if (value?.props?.value !== undefined) value = value.props.value;

            updateBeamPostDataVal(dataField, value);
        };

    const updateBeamPostDataVal = (dataField, value = null) => {
        if (!dataField.includes("Col")) window.job.QuoteParameters.ENGINEERING.EngineeringResults = null;

        let error = dispatch(updateAreaSpecificationBeamPost(areaIndex, null, dataField, value));
        if (error && error.error) {
            dispatch(APP.showDialog(error?.title ? error?.title : "", error.message ? error?.message : ""));
        }

        if (dataField === "BeamColMatchBeam" || dataField.includes("Col")) {
            console.log("UpdateBeams with BeamColMatchBeam");
            Paper.UpdateBeams(false, 1);
            // setTimeout(function(){ Paper.UpdateBeams(false); }, 500);
        }
        return;
    };

    const wipeBracing = () => {
        dispatch(updateAreaSpecification(areaIndex, "DECK_PARAMETERS", "DeckBracing", []));
    };
    const wipePosts = () => {
        dispatch(updateAreaSpecification(areaIndex, "DECK_PARAMETERS", "DeckPosts", []));
    };

    const updateBearerValue = (val = null) => {
        bearer_locations = bearer_locations.filter(function (item) {
            return item !== bearerLocationDialogValue;
        });
        bearer_locations.push(val ? val : updateBearerLocation);
        bearer_locations.sort();

        let new_locations = "";
        for (let loc of bearer_locations) {
            new_locations += (new_locations != "" ? "," : "") + loc;
        }
        updateBeamPostDataVal("BearerLocations", new_locations);

        setUpdateBearerLocation(0);
        setBearerLocationDialogValue("");
    };

    // let maxPostSpacing = MaxDeckBearerSpans(
    //     BeamPostParameters.BeamType1,
    //     area_design_specs.SHAPE.Length,
    //     area_design_specs.SHAPE.Depth,
    //     BeamPostParameters.BeamSpacing,
    //     BeamPostParameters.PostSpacing,
    //     beam1?.span_table
    // );
    let maxPostSpacing = 4000;
    // let maxBeamSpacing = MaxDeckJoistSpans(
    //     BeamPostParameters.BeamType2,
    //     BeamPostParameters.PurlinSpacing,
    //     area_design_specs.SHAPE.Length,
    //     BeamPostParameters.BeamSpacing,
    //     beam2?.span_table
    // );
    let maxBeamSpacing = 5000;

    let PostCapacity = 0;
    let JoistCapacity = 0;
    let BearerCapacity = 0;

    if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]) {
        if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.PostCapacity)
            PostCapacity = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.PostCapacity;
        if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.JoistCapacity)
            JoistCapacity = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.JoistCapacity;
        if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.BearerCapacity)
            BearerCapacity = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.BearerCapacity;
    }

    // DECK V2
    maxPostSpacing = 4000;
    maxBeamSpacing = 5000;

    let BracingSummary = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.BracingSummary;

    let bracing_ns_actual = BracingSummary?.bracing_ns_actual ? BracingSummary?.bracing_ns_actual : 0;
    let bracing_ns_required = BracingSummary?.bracing_ns_required ? BracingSummary?.bracing_ns_required : 0;
    let bracing_ns_capacity = bracing_ns_actual / bracing_ns_required;
    let bracing_ew_actual = BracingSummary?.bracing_ew_actual ? BracingSummary?.bracing_ew_actual : 0;
    let bracing_ew_required = BracingSummary?.bracing_ew_required ? BracingSummary?.bracing_ew_required : 0;
    let bracing_ew_capacity = bracing_ew_actual / bracing_ew_required;
    let bracing_capacity_min = Math.min(bracing_ns_capacity, bracing_ew_capacity);

    let bracing_required = area_design_specs.SHAPE.Height > 1000;

    let bearer_locations = [];
    if (BeamPostParameters?.BearerLocations) bearer_locations = BeamPostParameters?.BearerLocations.split(",");

    let FootingSummary = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.FootingSummary;

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>
                    {/* <span className={(beam1_eng_result <= 1 ? classes.header_pass : classes.header_fail)}>{beam1.Name}s - {(engValid && beam1_eng_result) ? (beam1_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <QuestionCircleIcon style={{ verticalAlign: "top" }} />} {(engValid && beam1_eng_result) ? (beam1_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    {/* <span className={((engValid && beam2_eng_result && beam2_eng_result > 0) ? (beam2_eng_result <= 1 ? classes.header_pass : classes.header_fail) : classes.header_unknown)}>{beam2.Name}s - {(engValid && beam2_eng_result) ? (beam2_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <CachedIcon style={{ verticalAlign: "top" }} />} {(engValid && beam2_eng_result) ? (beam2_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    {bracing_required && (
                        <span
                            className={
                                bracing_capacity_min >= 0
                                    ? bracing_capacity_min > 1
                                        ? classes.header_pass
                                        : classes.header_fail
                                    : classes.header_unknown
                            }
                        >
                            Bracing -{" "}
                            {bracing_capacity_min >= 0 ? (
                                bracing_capacity_min > 1 ? (
                                    <CheckCircleIcon style={{ verticalAlign: "middle" }} />
                                ) : (
                                    <CrossCircleIcon style={{ verticalAlign: "middle" }} />
                                )
                            ) : (
                                <CachedIcon style={{ verticalAlign: "middle" }} />
                            )}{" "}
                            {bracing_capacity_min >= 0 ? (bracing_capacity_min * 100).toFixed(1) + "%" : "??.?%"}
                        </span>
                    )}
                    {!bracing_required && (
                        <span className={classes.header_pass}>
                            Bracing - <CheckCircleIcon style={{ verticalAlign: "middle" }} /> {" *Not Required"}
                        </span>
                    )}
                </BSL_Common.SectionHeader>
                {area_design_specs.SHAPE.Height <= 1000 && (
                    <div className={classes.bracing}>
                        *bracing not required when height is less than or equal to 1m.
                    </div>
                )}
                {area_design_specs.SHAPE.Height > 1000 && (
                    <div className={classes.bracing}>
                        Must be over 100%.
                        <br />
                        *bracing required when height is greater than 1m.
                        <br />
                        To add bracing, click perimeter beam or bearer where you would like to add the bracing.
                    </div>
                )}
                <BSL_Common.SectionRow
                    style={{
                        fontSize: "14px",
                        padding: "0px 40px",
                    }}
                >
                    <BSL_Common.SectionColumn
                        style={{
                            font: "inherit",
                        }}
                    >
                        <b>DIRECTION</b>
                        <p
                            style={{
                                margin: 0,
                                color: "#1d1d1d",
                            }}
                        >
                            - <SwapVertIcon fontSize="small" style={{ verticalAlign: "middle", marginTop: "-2px" }} />{" "}
                            NS -
                        </p>
                        <p
                            style={{
                                margin: 0,
                                color: "#1d1d1d",
                            }}
                        >
                            - <SwapHorizIcon fontSize="small" style={{ verticalAlign: "middle", marginTop: "-4px" }} />{" "}
                            EW -
                        </p>
                    </BSL_Common.SectionColumn>
                    <BSL_Common.SectionColumn
                        style={{
                            font: "inherit",
                        }}
                    >
                        <b>ACTUAL</b>
                        <p
                            style={{
                                margin: 0,
                                color: bracing_ns_capacity >= 1 || !bracing_required ? "darkgreen" : "darkred",
                            }}
                        >
                            {bracing_ns_actual.toFixed(1)}kN
                        </p>
                        <p
                            style={{
                                margin: 0,
                                color: bracing_ew_capacity >= 1 || !bracing_required ? "darkgreen" : "darkred",
                            }}
                        >
                            {bracing_ew_actual.toFixed(1)}kN
                        </p>
                    </BSL_Common.SectionColumn>
                    <BSL_Common.SectionColumn
                        style={{
                            font: "inherit",
                        }}
                    >
                        <b>REQUIRED</b>
                        <p
                            style={{
                                margin: 0,
                                color: "#1d1d1d",
                            }}
                        >
                            {bracing_ns_required == "braced_by_attachment"
                                ? "0.0kN (attached)"
                                : toNumber(bracing_ns_required).toFixed(1) + "kN"}
                        </p>
                        <p
                            style={{
                                margin: 0,
                                color: "#1d1d1d",
                            }}
                        >
                            {bracing_ew_required == "braced_by_attachment"
                                ? "0.0kN (attached)"
                                : toNumber(bracing_ew_required).toFixed(1) + "kN"}
                        </p>
                    </BSL_Common.SectionColumn>
                </BSL_Common.SectionRow>
                <BSL_Button
                    style={{
                        marginLeft: "8px",
                        alignSelf: "center",
                        marginBottom: "8px",
                    }}
                    onClick={wipeBracing}
                >
                    Wipe All Bracing
                </BSL_Button>
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>
                    <span
                        className={
                            PostCapacity > 0
                                ? PostCapacity <= 1
                                    ? PostCapacity <= 0.9
                                        ? classes.header_pass
                                        : classes.header_warning
                                    : classes.header_fail
                                : classes.header_unknown
                        }
                    >
                        {post?.Name}s -{" "}
                        {PostCapacity > 0 ? (
                            PostCapacity <= 1 ? (
                                <CheckCircleIcon style={{ verticalAlign: "middle" }} />
                            ) : (
                                <CrossCircleIcon style={{ verticalAlign: "middle" }} />
                            )
                        ) : (
                            <CachedIcon style={{ verticalAlign: "middle" }} />
                        )}{" "}
                        {PostCapacity > 0 ? (PostCapacity * 100).toFixed(1) + "%" : "??.?%"}
                    </span>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background: PostCapacity > 0 ? (PostCapacity <= 1 ? "#99c995" : "#ff9a9a") : "#fff",
                    }}
                    value={BeamPostParameters.PostType}
                    tight={true}
                    items={post_menu_items}
                    onChange={updateBeamPostData("PostType")}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={areaIndex > 0 ? [post?.colours] : [post?.colours]}
                    value={BeamPostParameters.PostColMatchBeam}
                    onChange={updateBeamPostData("PostColMatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />
                {window.LYSAGHT && (
                    <SegmentedButtonGroup
                        label="Corner Post Position"
                        tight
                        value={BeamPostParameters.CornerPostsFullHeight}
                        items={[
                            {
                                Key: 1,
                                Display: "Beam to Side",
                            },
                            {
                                Key: 3,
                                Display: "Post Behind Beam",
                            },
                        ]}
                        onChange={updateBeamPostData("CornerPostsFullHeight")}
                        style={{
                            marginTop: "-8px",
                        }}
                    />
                )}
                <BSL_TextInput
                    label="Post Spacing"
                    value={BeamPostParameters?.PostSpacing}
                    tight
                    min={200}
                    max={maxPostSpacing}
                    endAdornment="mm"
                    onBlur={updateBeamPostData("PostSpacing")}
                    style={{
                        width: "120px",
                    }}
                />
                <BSL_Common.SectionRow>
                    <SegmentedButtonGroup
                        label="Footing Shape"
                        tight
                        value={BeamPostParameters.FootingShape}
                        items={[
                            {
                                Key: "Square",
                                Display: "Square",
                            },
                            {
                                Key: "Circular",
                                Display: "Circular",
                            },
                        ]}
                        onChange={updateBeamPostData("FootingShape")}
                        style={{
                            marginTop: "-8px",
                            minWidth: "140px",
                        }}
                    />
                    <BSL_Common.SectionRow
                        style={{
                            fontSize: "12px",
                            padding: "0px 0px",
                            paddingTop: "8px",
                            flex: 2,
                        }}
                    >
                        <BSL_Common.SectionColumn
                            style={{
                                font: "inherit",
                            }}
                        >
                            <b>SOIL TYPE</b>
                            <p
                                style={{
                                    margin: 0,
                                    color: "#1d1d1d",
                                }}
                            >
                                - SAND (A) -
                            </p>
                            <p
                                style={{
                                    margin: 0,
                                    color: "#1d1d1d",
                                }}
                            >
                                - CLAY (B) -
                            </p>
                        </BSL_Common.SectionColumn>
                        <BSL_Common.SectionColumn
                            style={{
                                font: "inherit",
                            }}
                        >
                            <b>{BeamPostParameters.FootingShape === "Square" ? "WIDTH" : "DIAMETER"}</b>
                            <p
                                style={{
                                    margin: 0,
                                    color: FootingSummary?.sand_passed ? "darkgreen" : "darkred",
                                }}
                            >
                                {FootingSummary?.sand_passed
                                    ? FootingSummary?.sand_passed_width + "mm"
                                    : FootingSummary?.clay_passed === undefined
                                    ? "??"
                                    : "Failed"}
                            </p>
                            <p
                                style={{
                                    margin: 0,
                                    color: FootingSummary?.clay_passed ? "darkgreen" : "darkred",
                                }}
                            >
                                {FootingSummary?.clay_passed
                                    ? FootingSummary?.clay_passed_width + "mm"
                                    : FootingSummary?.clay_passed === undefined
                                    ? "??"
                                    : "Failed"}
                            </p>
                        </BSL_Common.SectionColumn>
                        <BSL_Common.SectionColumn
                            style={{
                                font: "inherit",
                            }}
                        >
                            <b>DEPTH</b>
                            <p
                                style={{
                                    margin: 0,
                                    color: FootingSummary?.sand_passed ? "darkgreen" : "darkred",
                                }}
                            >
                                {FootingSummary?.sand_passed
                                    ? FootingSummary?.sand_passed_depth + "mm"
                                    : FootingSummary?.sand_passed === undefined
                                    ? "??"
                                    : "Failed"}
                            </p>
                            <p
                                style={{
                                    margin: 0,
                                    color: FootingSummary?.clay_passed ? "darkgreen" : "darkred",
                                }}
                            >
                                {FootingSummary?.clay_passed
                                    ? FootingSummary?.clay_passed_depth + "mm"
                                    : FootingSummary?.sand_passed === undefined
                                    ? "??"
                                    : "Failed"}
                            </p>
                        </BSL_Common.SectionColumn>
                    </BSL_Common.SectionRow>
                </BSL_Common.SectionRow>
                <BSL_Button style={{ marginLeft: "8px", alignSelf: "center" }} onClick={wipePosts}>
                    Wipe All Added Posts
                </BSL_Button>
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>
                    {/* <span className={(beam1_eng_result <= 1 ? classes.header_pass : classes.header_fail)}>{beam1.Name}s - {(engValid && beam1_eng_result) ? (beam1_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <QuestionCircleIcon style={{ verticalAlign: "top" }} />} {(engValid && beam1_eng_result) ? (beam1_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    {/* <span className={((engValid && beam1_eng_result && beam1_eng_result > 0) ? (beam1_eng_result <= 1 ? classes.header_pass : classes.header_fail) : classes.header_unknown)}>{beam1.Name}s - {(engValid && beam1_eng_result) ? (beam1_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <CachedIcon style={{ verticalAlign: "top" }} />} {(engValid && beam1_eng_result) ? (beam1_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    <span
                        className={
                            BearerCapacity > 0
                                ? BearerCapacity <= 1
                                    ? BearerCapacity <= 0.9
                                        ? classes.header_pass
                                        : classes.header_warning
                                    : classes.header_fail
                                : classes.header_unknown
                        }
                    >
                        {beam1?.Name}s -{" "}
                        {BearerCapacity > 0 ? (
                            BearerCapacity <= 1 ? (
                                <CheckCircleIcon style={{ verticalAlign: "middle" }} />
                            ) : (
                                <CrossCircleIcon style={{ verticalAlign: "middle" }} />
                            )
                        ) : (
                            <CachedIcon style={{ verticalAlign: "middle" }} />
                        )}{" "}
                        {BearerCapacity > 0 ? (BearerCapacity * 100).toFixed(1) + "%" : "??.?%"}
                    </span>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background: BearerCapacity > 0 ? (BearerCapacity <= 1 ? "#99c995" : "#ff9a9a") : "#fff",
                    }}
                    value={BeamPostParameters.BeamType1}
                    tight={true}
                    items={beam1_menu_items}
                    onChange={updateBeamPostData("BeamType1")}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={[beam1.colours]}
                    value={BeamPostParameters.BeamColMatchBeam}
                    onChange={updateBeamPostData("BeamColMatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        label="Bearer Locations"
                        value={newBearerLocation}
                        placeholder={"add new ->"}
                        tight
                        allowZero
                        min={1000}
                        max={area_design_specs.SHAPE.Length}
                        endAdornment="mm"
                        onBlur={(val) => {
                            if (val < 1000) return;
                            if (!bearer_locations.includes(String(val))) {
                                bearer_locations.push(val);
                                bearer_locations.sort();

                                let new_locations = "";
                                for (let loc of bearer_locations) {
                                    new_locations += (new_locations != "" ? "," : "") + loc;
                                }
                                setNewBearerLocation("");
                                updateBeamPostDataVal("BearerLocations", new_locations);
                            }
                        }}
                        style={{
                            maxWidth: "120px",
                        }}
                        helperText={"mm from the TOP edge"}
                    />

                    <SegmentedButtonGroup
                        label=" "
                        tight
                        // value={BeamPostParameters.PurlinSpacing}
                        items={bearer_locations}
                        // onChange={updateBeamPostData("PurlinSpacing")}
                        style={{
                            marginTop: "19px",
                        }}
                        onChange={(e, val) => {
                            console.log("click", val);
                            setUpdateBearerLocation(val);
                            setBearerLocationDialogValue(val);
                        }}
                    />
                </BSL_Common.SectionRow>

                <BSL_TextInput
                    label="Bearer Spacing"
                    value={BeamPostParameters?.BeamSpacing}
                    tight
                    allowZero
                    min={1000}
                    max={maxBeamSpacing}
                    endAdornment="mm"
                    onBlur={updateBeamPostData("BeamSpacing")}
                    style={{
                        marginTop: "-18px",
                        maxWidth: "120px",
                    }}
                    helperText={"0 = no extra bearers"}
                />
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>
                    {/* <span className={(beam1_eng_result <= 1 ? classes.header_pass : classes.header_fail)}>{beam1.Name}s - {(engValid && beam1_eng_result) ? (beam1_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <QuestionCircleIcon style={{ verticalAlign: "top" }} />} {(engValid && beam1_eng_result) ? (beam1_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    {/* <span className={((engValid && beam2_eng_result && beam2_eng_result > 0) ? (beam2_eng_result <= 1 ? classes.header_pass : classes.header_fail) : classes.header_unknown)}>{beam2.Name}s - {(engValid && beam2_eng_result) ? (beam2_eng_result <= 1 ? <CheckCircleIcon style={{ verticalAlign: "top" }} /> : <CrossCircleIcon style={{ verticalAlign: "top" }} />) : <CachedIcon style={{ verticalAlign: "top" }} />} {(engValid && beam2_eng_result) ? (beam2_eng_result * 100).toFixed(1) + "%" : "??.?%"}</span> */}
                    <span
                        className={
                            JoistCapacity > 0
                                ? JoistCapacity <= 1
                                    ? JoistCapacity <= 0.9
                                        ? classes.header_pass
                                        : classes.header_warning
                                    : classes.header_fail
                                : classes.header_unknown
                        }
                    >
                        {beam2?.Name}s -{" "}
                        {JoistCapacity > 0 ? (
                            JoistCapacity <= 1 ? (
                                <CheckCircleIcon style={{ verticalAlign: "middle" }} />
                            ) : (
                                <CrossCircleIcon style={{ verticalAlign: "middle" }} />
                            )
                        ) : (
                            <CachedIcon style={{ verticalAlign: "middle" }} />
                        )}{" "}
                        {JoistCapacity > 0 ? (JoistCapacity * 100).toFixed(1) + "%" : "??.?%"}
                    </span>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background: JoistCapacity > 0 ? (JoistCapacity <= 1 ? "#99c995" : "#ff9a9a") : "#fff",
                    }}
                    value={BeamPostParameters.BeamType2}
                    tight={true}
                    items={beam2_menu_items}
                    onChange={updateBeamPostData("BeamType2")}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={[beam2.colours]}
                    value={BeamPostParameters.BeamCol2MatchBeam}
                    onChange={updateBeamPostData("BeamCol2MatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />

                <SegmentedButtonGroup
                    label="Joist Spacing"
                    tight
                    value={BeamPostParameters.PurlinSpacing}
                    items={[300, 450, 600]}
                    onChange={updateBeamPostData("PurlinSpacing")}
                    style={{
                        marginTop: "-12px",
                    }}
                />

                <BSL_CheckBox
                    tight
                    checked={BeamPostParameters.MatchSideBeams}
                    returnInt
                    label="Match Edge Joist To Bearer"
                    onChange={updateBeamPostData("MatchSideBeams")}
                    style={{
                        marginTop: "-12px",
                    }}
                />
            </BSL_Common.SectionContainer>

            <BSL_Dialog
                title={"Edit Bearer Location"}
                open={bearerLocationDialogValue !== ""}
                onClose={() => {
                    setBearerLocationDialogValue("");
                }}
                button1Text="Update"
                button1Click={() => {
                    updateBearerValue(updateBearerLocation);
                }}
                button2Text="Delete"
                button2Click={() => {
                    bearer_locations = bearer_locations.filter(function (item) {
                        return item !== bearerLocationDialogValue;
                    });

                    let new_locations = "";
                    for (let loc of bearer_locations) {
                        new_locations += (new_locations != "" ? "," : "") + loc;
                    }
                    updateBeamPostDataVal("BearerLocations", new_locations);
                    setUpdateBearerLocation(0);
                    setBearerLocationDialogValue("");
                }}
                style={{ maxWidth: "initial" }}
            >
                <BSL_TextInput
                    label="Bearer Spacing"
                    value={updateBearerLocation}
                    tight
                    min={1000}
                    max={maxBeamSpacing}
                    autoFocus
                    selectAll
                    endAdornment="mm"
                    onBlur={(val) => {
                        setUpdateBearerLocation(val);
                    }}
                    onEnter={(e) => {
                        setUpdateBearerLocation(e.target.value);
                        updateBearerValue(e.target.value);
                    }}
                    style={{
                        marginTop: "-18px",
                        maxWidth: "120px",
                    }}
                    helperText={"0 = no extra bearers"}
                />
            </BSL_Dialog>
        </div>
    );
}
